import { useEffect } from 'react';
import * as VanillaCookieConsent from 'vanilla-cookieconsent';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import { GAService } from '../../services/ga';
import { GTMService } from '../../services/gtm';
import { HotjarService } from '../../services/hotjar';

export const useCookieConsent = () => {
  const initServicesBasedOnConsent = () => {
    const preferences = VanillaCookieConsent.getUserPreferences();
    const services = preferences.acceptedCategories;

    if (services.includes('analytics')) {
      HotjarService.init();
      GTMService.init();
      GAService.init();
    }
  };

  useEffect(() => {
    VanillaCookieConsent.run({
      onFirstConsent: () => {
        initServicesBasedOnConsent();
      },
      onChange: () => {
        window.location.reload(); // reload to freshly init new services init
      },
      guiOptions: {
        consentModal: { layout: 'cloud', position: 'bottom right' },
      },
      categories: {
        necessary: {
          enabled: true, // this category is enabled by default
          readOnly: true, // this category cannot be disabled
        },
        analytics: {},
      },
      language: {
        default: 'cs',
        translations: {
          cs: '/locales/cs/cookies_cs.json',
        },
      },
    }).finally(() => initServicesBasedOnConsent());
  }, []);

  const getPreferences = () => {
    return VanillaCookieConsent.getUserPreferences();
  };

  return {
    getPreferences,
  };
};

export const useCookieConsentControl = () => {
  const show = () => {
    return VanillaCookieConsent.showPreferences();
  };

  return {
    show,
  };
};
